import { render, staticRenderFns } from "./card_edit.vue?vue&type=template&id=16083487&scoped=true"
import script from "./card_edit.vue?vue&type=script&lang=js"
export * from "./card_edit.vue?vue&type=script&lang=js"
import style0 from "./card_edit.vue?vue&type=style&index=0&id=16083487&prod&lang=css"
import style1 from "./card_edit.vue?vue&type=style&index=1&id=16083487&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16083487",
  null
  
)

export default component.exports